module.exports = __webpack_public_path__ + "img/sthree.1c96d72f.png";